import { Link } from "react-router-dom";

const promises = [
  { icon: "ri-time-line", title: "先核实再发布", desc: "花絮与幕后信息尽量交叉比对，无法确认的内容会明确标注。" },
  { icon: "ri-user-star-line", title: "主创优先署名", desc: "导演、编剧与演员的资料按实际署名整理，不随意猜测角色归属。" },
  { icon: "ri-scales-3-line", title: "分数不做买卖", desc: "口碑评分只统计真实观剧记录，不接受任何形式的分数干预。" },
];

export default function AboutBand() {
  return (
    <section className="bg-secondary-950">
      <div className="mx-auto w-full max-w-content px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:items-center">
          <div className="lg:col-span-5">
            <span className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.24em] text-accent-400">
              <span className="h-1 w-1 rounded-full bg-accent-500" />
              关于短剧爆料社
            </span>
            <h2 className="mt-2.5 font-heading text-2xl font-bold tracking-tight text-background-50 md:text-3xl">
              我们只写镜头背后真实发生的事
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-secondary-200">
              短剧爆料社是一个专注短剧主创信息的编辑团队，把零散的演员表、导演编剧信息、拍摄花絮与观众口碑整理到一起，
              让每一部作品都有一条清晰可查的资料线。
            </p>
            <Link
              to="/about"
              className="mt-6 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-medium text-secondary-950 transition-colors hover:bg-accent-400"
            >
              了解我们的内容原则
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 lg:col-span-7">
            {promises.map((item) => (
              <div
                key={item.title}
                className="rounded-lg border border-secondary-700 bg-secondary-900/60 p-5"
              >
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 text-secondary-950">
                  <i className={`${item.icon} text-lg`}></i>
                </span>
                <h3 className="mt-4 font-heading text-sm font-semibold text-background-50">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs leading-relaxed text-secondary-200">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}